import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import store from './store'
import vPrint from 'vue-print-nb'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI);
Vue.use(vPrint);
Vue.config.productionTip = false
const urlA = 'https://www.wzdyy.com:8088'
const urlB = 'https://127.0.0.1:8088'

//设置超时时间
axios.defaults.timeout = 5000
axios.defaults.baseURL = urlA
Vue.prototype.$http = axios
Vue.prototype.$LoginName = Vue.observable({
	value: ''
});

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')